import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../theme";
import Navbar from "../../components/Navbar/Navbar";
import MainPoint from "./MainPoint";
import Benefits from "./Benefits";
import EarningsCalculator from "./EarningsCalculator";
import TrustAndSafety from "./TrustAndSafety.js";
import CallToAction from "./CallToAction";
import Footer from "../../components/Footer/Footer";
import "./Listing.css";

const Listing = () => {
  return (
    <ThemeProvider theme={theme}>
      <div className="listing-page">
        <Navbar />
        <MainPoint />
        <Benefits />
        <EarningsCalculator />
        <TrustAndSafety />
        <CallToAction />
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default Listing;
